import React from 'react';

export interface ITableLikeTreeItem {
    id: number;
    title?: string;
    children?: ITableLikeTreeItem[];
    treeLevel?: number;
    treeLevelShift?: number;
    parent?: ITableLikeTreeItem;
    parentId?: number | null;
    isFirstChild?: boolean;
    isLastChild?: boolean;
    codeWBS?: string | null;
    hasWorItems?: boolean;
}

export interface ITableLikeTreeItemNotificationItem {
    message?: string;
    icon?: React.ReactNode;
}

export interface ITableLikeTreeItemNotification {
    treeItemId: number;
    items: ITableLikeTreeItemNotificationItem[];
}

export interface ITableLikeTreeCheckConfirmationItem {
    message: string;
    confirmLabel?: string;
    cancelLabel?: string;
}

export interface ITableLikeTreeCheckNotificationItem {
    treeItemId: number;
    message: string;
}

export interface ITableLikeTreeCheckConfirmation {
    treeItemId: number;
    onCheck?: ITableLikeTreeCheckConfirmationItem;
    onUncheck?: ITableLikeTreeCheckConfirmationItem;
}

export interface ITableLikeTreeContext {
    onCheckChange: (item: ITableLikeTreeItem, isChecked: boolean) => any;
    switchCheckAll: (checkAll: boolean) => any;
    checkedIds: number[];
    onDragStart: (item: ITableLikeTreeItem) => any;
    rowsCount: number;
    rootLevelItems: ITableLikeTreeItem[];
    allItems: ITableLikeTreeItem[];
    shownIds: number[];
    shownIdsSet?: Set<number>;
    switchExpandAll: (expandAll: boolean) => any;
    hideItems: (itemsIds: number[]) => any;
    showItems: (itemsIds: number[]) => any;
    currentDragged: ITableLikeTreeItem | null;
    onDrop: (source: ITableLikeTreeItem, target: ITableLikeTreeItem, isInsert?: boolean, isBefore?: boolean) => any;
    informers?: ITableLikeTreeItemNotification[];
    onInformerClose?: (treeItemId: number) => any;
    onInformersClose?: () => any;
    delete: (item: ITableLikeTreeItem) => any;
    replace: (item: ITableLikeTreeItem) => any;
    addChild: (child: ITableLikeTreeItem, parent?: ITableLikeTreeItem) => any;
    isRootItemUnableToAppend?: boolean;
    isItemMovableOnlyInsideRootItemBrunch?: boolean;
    isItemMovableOnlyInsideParent?: boolean;
    areCheckboxesDisabled?: boolean;
    firstRowInformerMessage?: string;
    checkConfirmations?: ITableLikeTreeCheckConfirmation[];
    disabledCheckBoxesItemsIds?: number[];
    dragOperationDisabledItemsIds?: number[];
    checkBoxesNotifications?: ITableLikeTreeCheckNotificationItem[];
    areAllExpanded?: boolean;
    startPointerDropMode?: (source: ITableLikeTreeItem, options?: { mode?: 'copy' | 'move'; label?: string }) => void;
    stopPointerDropMode?: () => void;
    isPointerDropMode?: boolean;
    pointerMode?: 'copy' | 'move';
}

export interface ITableLikeTreeMenuOperationContext {
    context: ITableLikeTreeContext;
    item: ITableLikeTreeItem;
}

export interface ITableLikeTreeFilterItem {
    id: number;
    title: string;
    isFirstActive?: boolean;
    isLastActive?: boolean;
}

export const TableLikeTreeContext = React.createContext<ITableLikeTreeContext>({} as any);
